'use client'

import { cn } from '@/lib/utils'
import { BodyText, LeftCaretIcon } from 'design-configuration/components'
import { motion } from 'motion/react'
import React, { useState } from 'react'

interface AccordionProps {
  title: string
  children: React.ReactNode
  titleClassName?: string
}

const Accordion: React.FC<AccordionProps> = ({ title, children, titleClassName }) => {
  const [isOpen, setIsOpen] = useState(false)

  const toggleAccordion = () => {
    setIsOpen(!isOpen)
  }

  return (
    <motion.div className={`gap-y-xs flex w-full flex-col`}>
      <motion.button
        className="text-on-surface gap-x-2xs flex w-full items-center text-left"
        onClick={toggleAccordion}
        layout
      >
        <BodyText className={titleClassName}>{title}</BodyText>
        <div className="gap-x-xs flex items-center">
          <motion.div
            animate={{
              rotate: isOpen ? 90 : 270
            }}
            transition={{ duration: 0.2 }}
          >
            <LeftCaretIcon className={cn(`w-sm h-sm fill-on-surface`, titleClassName)} />
          </motion.div>
        </div>
      </motion.button>
      {isOpen ? (
        <motion.div layout initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}>
          {children}
        </motion.div>
      ) : null}
    </motion.div>
  )
}

export default Accordion
